<template>
  <c-button
    flat
    :class="[ 'c-collapsible-card-button', { '--opened': opened } ]"
    icon="arrow-left"
    icon-size="17"
    size="30"
    type="button"
    v-bind="$attrs"
    v-on="componentListeners"
  />
</template>

<script>
import useVue3Migration from '@convenia/composables/useVue3Migration'
import CButton from '@convenia/components/CButton'

export default {
  inheritAttrs: false,

  components: {
    CButton
  },

  props: {
    opened: Boolean
  },

  setup (_, ctx) {
    const { componentListeners } = useVue3Migration(ctx)

    return { componentListeners }
  }
}
</script>

<style lang="scss">
.c-collapsible-card-button.c-button {
  padding: 0 2px 2px 0;
  transform: rotate(270deg);
  transition: .2s ease-out;

  &.--opened { transform: rotate(90deg); }

  & > .icon { margin-bottom: -1px; }
}
</style>
